import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { get } from 'lodash'
import { Typography } from '@material-ui/core'

import api from 'common/api'

import asyncThrottler from '@scoir/async-throttler'
import { ConfirmationDialog } from '@scoir/modals'

import SlateSetupPresentation from './SlateSetupPresentation'

class SlateSetup extends React.Component {
  static propTypes = {
    scid: PropTypes.number.isRequired,
  }
  state = {
    isLoaded: false,
    isProcessing: false,
    isComplete: false,
    testResult: undefined,
    isActive: false,
    domainModified: false,
    consolidateBatches: false,
    isConfirmModalOpen: false,
  }
  componentDidMount() {
    this.throttler = asyncThrottler.create((state) => this.setState(state))
    api.get(`/api/colleges/${this.props.scid}/integrations`).then((integrations) =>
      this.setState({
        isLoaded: true,
        isActive: get(integrations, 'Slate.Status') === 'Live',
        domain: get(integrations, 'Slate.Subdomain'),
        consolidateBatches: get(integrations, 'ConcatenateBatchTranscripts'),
      }),
    )
  }
  testConnection() {
    const apiPromise = api
      .get(`/api/colleges/${this.props.scid}/integrations/slate/test`)
      .then(() => {
        this.setState({ testResult: true })
      })
      .catch(() => {
        this.setState({
          testResult: false,
          isActive: false,
        })
      })
    this.throttler.execute(apiPromise)
  }
  toggleActivation(newActivatedState) {
    const activationRoute = `/api/colleges/${this.props.scid}/integrations/slate/activate`
    let promise
    if (newActivatedState) {
      promise = api.post(activationRoute)
    } else {
      promise = api.delete(activationRoute)
    }
    promise.then(() => this.setState({ isActive: newActivatedState }))
  }
  saveDomain(domain) {
    api
      .post(`/api/colleges/${this.props.scid}/integrations/slate/config`, {
        Subdomain: domain,
      })
      .then(() => this.setState({ domain, domainModified: false }))
  }
  verifySlateIntegration = (toggleActive) => {
    if (toggleActive && this.state.consolidateBatches) {
      this.setState({ isConfirmModalOpen: true })
    } else {
      this.toggleActivation(toggleActive)
    }
  }
  confirmSlate = () => {
    api.delete(`/api/colleges/${this.props.scid}/integrations/batch/concatenatetranscripts`).then(() => {
      this.setState({ isConfirmModalOpen: false })
      return this.toggleActivation(true)
    })
  }
  render() {
    let testResult
    if (this.state.isComplete) {
      testResult = this.state.testResult
    }
    return (
      this.state.isLoaded && (
        <Fragment>
          <SlateSetupPresentation
            isSyncing={this.state.isProcessing}
            testResult={testResult}
            isActive={this.state.isActive}
            domain={this.state.domain}
            needsSaved={this.state.domainModified}
            onTestConnection={() => this.testConnection()}
            onActivateToggle={this.verifySlateIntegration}
            onDomainSave={(domain) => this.saveDomain(domain)}
            onDomainModification={() => this.setState({ domainModified: true, testResult: undefined })}
          />
          <ConfirmationDialog
            open={this.state.isConfirmModalOpen}
            headerText="Confirm Slate Integration"
            onConfirm={this.confirmSlate}
            onClose={() => this.setState({ isConfirmModalOpen: false })}
          >
            <Typography>
              Slate is not setup to receive and process individual pdfs as one consolidated pdf. Enabling Slate
              Integration will revert your current Delivery Preference to individual pdfs.
            </Typography>
          </ConfirmationDialog>
        </Fragment>
      )
    )
  }
}

export default SlateSetup
